var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-lunbo'),_c('fanwei'),_c('liucheng'),_c('about'),_c('anli'),_c('ditu'),_c('chanpin'),_c('lianxi')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }